// @mui
import {alpha, styled} from '@mui/material/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({active, depth, config, theme}) => {
  const subItem = depth !== 1;

  const deepSubItem = depth > 2;

  const activeStyles = {
    root: {
      'color': `${theme.palette.primary.light}`,
      'backgroundColor': alpha(theme.palette.primary.main, 0.16),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.24),
      },
    },
    sub: {
      'color': '#E2E8F0',
      'backgroundColor': 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
  };

  return {
    // Root item
    padding: config.itemPadding,
    marginBottom: config.itemGap,
    borderRadius: config.itemRadius,
    minHeight: config.itemRootHeight,
    color: '#FFFFFF',

    // Active root item
    ...(active && {
      ...activeStyles.root,
    }),

    // Sub item
    ...(subItem && {
      minHeight: config.itemSubHeight,
      // Active sub item
      ...(active && {
        ...activeStyles.sub,
      }),
    }),

    // Deep sub item
    ...(deepSubItem && {
      paddingLeft: theme.spacing(depth),
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)(({size}) => ({
  width: size,
  height: size,
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledDotIcon = styled('span')(({active, theme}) => ({
  width: 4,
  height: 4,
  borderRadius: '50%',
  backgroundColor: 'rgba(226, 232, 240, 0.4)',
  transition: theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(active && {
    transform: 'scale(2)',
    backgroundColor: theme.palette.primary.light,
  }),
}));

// ----------------------------------------------------------------------

export const StyledSubheader = styled(ListSubheader)(({config, theme}) => ({
  ...theme.typography.overline,
  'fontSize': 12,
  'cursor': 'pointer',
  'display': 'inline-flex',
  'padding': config.itemPadding,
  'paddingTop': theme.spacing(1),
  'marginBottom': config.itemGap,
  'paddingBottom': theme.spacing(1),
  'color': 'rgba(226, 232, 240, 0.6)',
  'transition': theme.transitions.create(['color'], {
    duration: theme.transitions.duration.shortest,
  }),
  '&:hover': {
    color: '#E2E8F0',
  },
}));
